import axios from 'axios';
import { WhatsAppMessage } from '../types';

// Chatbot backend (conversations DB) — same wiring as touchpoint-portal's
// conversationsApi. Read-only here: the portal only fetches reply content.
const CONVERSATIONS_API_URL = 'https://chat-service.bhuvanafortunegreens.com';
const INTERNAL_API_KEY = 'a8f3j9k2m5n7p1q4r6s8t0u2v5w7x9y1';

const chatClient = axios.create({
  baseURL: CONVERSATIONS_API_URL,
  headers: {
    'Content-Type': 'application/json',
    'X-API-Key': INTERNAL_API_KEY,
  },
});

export const chatApi = {
  getMessages: async (
    conversationId: string,
    opts?: { limit?: number; before?: string }
  ): Promise<{ messages: WhatsAppMessage[]; has_more: boolean }> => {
    const params: Record<string, string | number> = {};
    if (opts?.limit) params.limit = opts.limit;
    if (opts?.before) params.before = opts.before;
    const response = await chatClient.get(`/messages/${conversationId}`, { params });
    return response.data;
  },
};
